export enum AuthApiTags {
  loginMethods = "loginMethods",
}
